import { useAppSelector } from '@/store/hooks';
import { selectIsSavingWorkingProject } from '@/store/slices/project/selectors';
import Modal from '@ui/modal/modal';
import Text from '@ui/text/text/text';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Button from '@ui/buttons/button/button';
import { ISiteDetailMetadata } from '../../settings.types';
import SiteSearchCardList from './site-search-card-list';

type SiteSearchPreviewModalProps = {
  open: boolean;
  handleClose: () => void;
  metadata?: ISiteDetailMetadata;
};

const SiteSearchPreviewModal = ({ open, metadata, handleClose }: SiteSearchPreviewModalProps) => {
  const isSaving = useAppSelector(selectIsSavingWorkingProject);

  return (
    <>
      <Modal
        open={open}
        fadeTransition={false}
        transitionDuration={400}
        size="full"
        withZoom={false}
        backgroundColor="var(--gray-1000)"
        showBackdrop={false}
        delayContentRender={150}
        onRequestClose={!isSaving ? handleClose : undefined}
        RenderHeaderContent={() => {
          return (
            <Container background="transparent" padding="24px 40px 16px">
              <div className="flex ai-center jc-space-between">
                <Text tag="h2" className="H2" color="var(--gray-200)">
                  Preview
                </Text>
                <Button
                  className="radius-100 padding-12"
                  width="40px"
                  height="40px"
                  backgroundColor="var(--gray-600)"
                  onClick={handleClose}
                >
                  <Icon name={ICONS.CLOSE} size={16} />
                </Button>
              </div>
            </Container>
          );
        }}
      >
        <Container className="flex jc-center ai-center" height="auto" minHeight="calc(100% - 80px)">
          <Container
            className="flex ai-center jc-center padding-40 radius-16"
            width="860px"
            background="rgb(0,0,0,0.1)"
            borderRadius="8px"
          >
            <Container
              className="flex-column ai-center jc-center gap-24 padding-40"
              width="100%"
              background="var(--gray-1000)"
              borderRadius="12px"
            >
              <SiteSearchCardList metadata={metadata} />
            </Container>
          </Container>
        </Container>
      </Modal>
    </>
  );
};

export default SiteSearchPreviewModal;
